import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  searchExternalUsersSuccess,
  searchExternalUsersFailure,
  getAssociatedTalentsSuccess,
  getAssociatedTalentsFailure,
  searchSkillListingQuerySuccess,
  searchSkillListingQueryFailure,
  getExternalUserDetailSuccess,
  getExternalUserDetailFailure,
  nlSearchExternalSuccess,
  nlSearchExternalFailure,
  fetchExternalContactSuccess,
  fetchExternalContactFailure,
} from "../actions";
import {
  searchExternalUsersAPI,
  getAssociatedTalentsAPI,
  searchSkillListingQueryAPI,
  searchPmtTalentsAPI,
  getExternalUserDetailAPI,
  nlSearchExternalAPI,
  fetchExternalContactAPI,
} from "../../API/API";

// ── External Talent (profile/external_users/search) ──────────────────────────
function* searchExternalUsersSaga(action) {
  try {
    const response = yield call(searchExternalUsersAPI, action.payload);
    yield put(searchExternalUsersSuccess(response.data));
  } catch (error) {
    yield put(searchExternalUsersFailure(error));
  }
}

export function* watchSearchExternalUsersSaga() {
  yield takeEvery(types.SEARCH_EXTERNAL_USERS_INIT, searchExternalUsersSaga);
}

// ── Internal Talent (guest/associated-talents) ────────────────────────────────
function* getAssociatedTalentsSaga(action) {
  try {
    const response = yield call(getAssociatedTalentsAPI, action.payload);
    yield put(getAssociatedTalentsSuccess(response.data));
  } catch (error) {
    yield put(getAssociatedTalentsFailure(error));
  }
}

export function* watchGetAssociatedTalentsSaga() {
  yield takeEvery(types.GET_ASSOCIATED_TALENTS_INIT, getAssociatedTalentsSaga);
}

// Marketplace talent: legacy GraphQL for public search, REST for signed-in search.
function* searchSkillListingQuerySaga(action) {
  try {
    const searchAPI = action.payload?.usePmtTalentsSearch
      ? searchPmtTalentsAPI
      : searchSkillListingQueryAPI;
    const response = yield call(searchAPI, action.payload);
    yield put(searchSkillListingQuerySuccess(response.data));
  } catch (error) {
    yield put(searchSkillListingQueryFailure(error));
  }
}

export function* watchSearchSkillListingQuerySaga() {
  yield takeEvery(
    types.SEARCH_SKILLLISTING_QUERY_INIT,
    searchSkillListingQuerySaga
  );
}

// ── External Talent detail (profile/external_users/:id) ───────────────────────
function* getExternalUserDetailSaga(action) {
  try {
    const response = yield call(getExternalUserDetailAPI, action.payload);
    yield put(getExternalUserDetailSuccess(response.data));
  } catch (error) {
    yield put(getExternalUserDetailFailure(error));
  }
}

export function* watchGetExternalUserDetailSaga() {
  yield takeEvery(types.GET_EXTERNAL_USER_DETAIL_INIT, getExternalUserDetailSaga);
}

function* fetchExternalContactSaga(action) {
  try {
    const { id, callback } = action.payload;

    const response = yield call(fetchExternalContactAPI, id);

    yield put(fetchExternalContactSuccess(response.data));

    if (callback) {
      callback();
    }

  } catch (error) {
    yield put(fetchExternalContactFailure(error));
  }
}

export function* watchFetchExternalContactSaga() {
  yield takeEvery(types.FETCH_EXTERNAL_CONTACT_INIT, fetchExternalContactSaga);
}

function* nlSearchExternalSaga(action) {
  try {
    const response = yield call(nlSearchExternalAPI, action.payload);
    yield put(nlSearchExternalSuccess(response.data));
  } catch (error) {
    const errorMessage = error?.response?.data?.errorMessage || null;
    const errorType = error?.response?.data?.errorType || null;
    yield put(nlSearchExternalFailure({ errorMessage, errorType }));
  }
}

export function* watchNlSearchExternalSaga() {
  yield takeEvery(types.NL_SEARCH_EXTERNAL_INIT, nlSearchExternalSaga);
}
